export enum FrameworkCategory {
  NIST800171 = "NIST_800_171",
  NIST80053 = "NIST_800_53",
  CMMC = "CMMC",
  CMMCv20 = "CMMC_20",
  HIPAA = "HIPPA",
  GDPR = "GDPR"
}

export namespace FrameworkCategory {
  export function containsCMMC(frameworkCategory: FrameworkCategory): boolean {
    if (frameworkCategory && frameworkCategory.toLocaleLowerCase().includes("cmmc")) {
      return true;
    } else {
      return false;
    }
  }
}